module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_leaf-3996995419c13565ae6b28a9616cab97.svg";